import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { AlertService } from '@app/alert/service/alert.service'
import { UserContextService } from '@core/service/user-context.service'
import { Observable, throwError } from 'rxjs'
import { catchError } from 'rxjs/operators'

const unauthorizedMsg = 'Você não tem permissão para realizar essa ação'
const accessDeniedMsg = 'Você não tem permissão para acessar esse recurso'

@Injectable({
  providedIn: 'root',
})
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private userContext: UserContextService, private alertService: AlertService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    const newRequest = request.clone({
      withCredentials: true,
    })

    return next.handle(newRequest).pipe(
      catchError((err) => {
        if (this.userContext.isInitialized && !request.url.endsWith('api/authorize')) {
          if (401 === err.status) {
            this.userContext.destroy()
            this.alertService.showError(unauthorizedMsg, 'Acesso negado')
            this.router.navigateByUrl('/login')
          } else if (403 === err.status) {
            this.alertService.showError(typeof err.error === 'string' ? err.error : accessDeniedMsg, 'Acesso negado')
            this.userContext.refreshAndDetectUserChanges()
            this.router.navigateByUrl('/erro/403')
          }
        }

        if (err.status?.toString().startsWith('5')) {
          this.alertService.showError(
            'O servidor encontrou problemas ao servir sua requisição. Contate a equipe de suporte através do e-mail residencias@saude.gov.br.'
          )
        }

        return throwError(err)
      })
    )
  }
}
